export const TagTypes = {
  SINGLE_STORY: 'single_story'
}
